import { DASHBOARDS, type TDashboard } from 'App/dashboards/dashboards'
import { useMemo } from 'react'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'

// Dashboards the user can actually use: each dashboard applies its own access check via
// `isAccessible` (pest = degree-day/trap-catch permission; water = irrigation/soil permission; etc.),
// so this stays family-agnostic. Shared by the All Dashboards list and the side-nav entry (which
// hides itself when this is empty) so the two can't diverge. Unsorted — callers apply their own order.
export const useAccessibleDashboards = (): TDashboard[] => {
  const properties = fieldAssetStore.useSelector((s) => s.properties)
  // Read via each dashboard's isAccessible; kept in deps so this recomputes when permissions load.
  const permissions = userDetailsStore.useSelector((s) => s.permissions)

  return useMemo(() => {
    const propertyIds = Object.keys(properties ?? {}).map(Number)

    return DASHBOARDS.filter((d) => d.isAccessible(propertyIds))
  }, [properties, permissions])
}
